import { mapArrayToProp } from "@mcwd/typescript-type-guards";
import { LocaleSettingsArray } from "../locale-settings.js";

export const LocaleUrlPrefix = mapArrayToProp(LocaleSettingsArray, "UrlPrefix");
export type LocaleUrlPrefix = typeof LocaleUrlPrefix[number];

